import { Stack, Box, Typography } from '@mui/material'
import { VideoCard, ChannelCard } from './'

const Videos = ({ videos, direction }) => {
  console.log( 'VIDEOS', videos)
  if (!videos?.length) return <Typography variant='h5' sx={{ color: 'white', fontSize: '1rem' }}>Loading...</Typography>

  return (
    <Stack direction={direction || 'row'} flexWrap='wrap' gap={2} justifyContent='center'>
      {videos.map((item, idx) => (
        <Box key={idx}>
          {item.id.videoId && <VideoCard video={item} />}
          {item.id.channelId && <ChannelCard channelDetail={item} />}
        </Box>
      ))}
    </Stack>
  )
}

export default Videos